import { z } from 'zod';

/** Moves the alchemy engine accepts. Must match game-core's `AlchemyMove`. */
export const alchemyMoveSchemas = [z.object({ type: z.literal('brew'), reagents: z.array(z.number().int().min(0).max(11)).max(5) })] as const;

const reagent = z.object({ name: z.string(), p: z.number(), t: z.number(), v: z.number() });

export const alchemyViewSchema = z.object({
  /** A reagent not `known` shows its usual potency; this batch's may be one either side. */
  offer: z.array(reagent.extend({ known: z.boolean() })),
  /** The recipe: exact potency, toxicity at most, volatility at most. */
  potency: z.number(),
  toxicity: z.number(),
  volatility: z.number(),
  maxReagents: z.number().int(),
  maxEach: z.number().int(),
  timeLimitMs: z.number(),
  brewed: z.object({ reagents: z.array(z.number().int()), potency: z.number(), toxicity: z.number(), volatility: z.number(), late: z.boolean() }).nullable(),
});
export type AlchemyView = z.infer<typeof alchemyViewSchema>;
